import React from 'react';
import MallaForm from './MallaForm';

const ModalWrapper = ({ open, title, children, onClose, size = 'modal-lg' }) => {
  if (!open) return null;
  return (
    <div
      className="modal fade show d-block management-modal"
      tabIndex="-1"
      role="dialog"
      aria-modal="true"
      style={{ backgroundColor: 'rgba(15, 23, 42, 0.45)' }}
    >
      <div className={`modal-dialog ${size} modal-dialog-centered`} role="document">
        <div className="modal-content">
          <div className="modal-header border-0">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="btn-close" aria-label="Cerrar" onClick={onClose} />
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default function MallaModal({
  modal,
  mallaSeleccionada,
  formNuevo,
  setFormNuevo,
  materiasRegistradas,
  savingNuevo,
  deleting,
  onAgregar,
  onEliminar,
  onClose,
}) {
  return (
    <>
      <ModalWrapper
        open={modal === 'nuevo'}
        title="Agregar materia a malla"
        onClose={onClose}
        size="modal-lg"
      >
        <div className="modal-body">
          <MallaForm
            form={formNuevo}
            setForm={setFormNuevo}
            mode="nuevo"
            loading={savingNuevo}
            materiasRegistradas={materiasRegistradas}
          />
        </div>
        <div className="modal-footer border-0">
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={onClose}
            disabled={savingNuevo}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="btn management-btn-primary"
            onClick={onAgregar}
            disabled={savingNuevo || !formNuevo.materia_id}
          >
            {savingNuevo ? 'Guardando...' : 'Guardar'}
          </button>
        </div>
      </ModalWrapper>

      <ModalWrapper
        open={modal === 'eliminar'}
        title="Eliminar materia"
        onClose={onClose}
        size="modal-md"
      >
        <div className="modal-body">
          {mallaSeleccionada && (
            <>
              <p className="mb-2">
                Estas a punto de eliminar la materia{' '}
                <strong>{mallaSeleccionada.materia_nombre}</strong> de la malla de este curso.
              </p>
              <p className="text-muted mb-0">
                Esta accion no eliminara la materia del catalogo, solo la removera de este curso.
              </p>
            </>
          )}
        </div>
        <div className="modal-footer border-0">
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={onClose}
            disabled={deleting}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={onEliminar}
            disabled={deleting}
          >
            {deleting ? 'Eliminando...' : 'Eliminar'}
          </button>
        </div>
      </ModalWrapper>
    </>
  );
}
